var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "requirements" }, [
    _vm.prefix
      ? _c("span", { staticClass: "prefix" }, [_vm._v(_vm._s(_vm.prefix))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.requirements, function(requirement) {
        return _c(
          "li",
          { key: requirement.key, class: { valid: requirement.valid } },
          [
            _c("Icon", {
              attrs: { icon: requirement.valid ? "checkmark" : "close" }
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(requirement.label))])
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }